import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Fade from '@mui/material/Fade';
import LineItem from './LineItem';

const styles = () => ({
  root: {},
});

const Body = ({
  className,
  classes,
  sectionResource,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {sectionResource.attr('accounts').resources().list().map((resource, index) => {
        return (
          <Fade
            key={resource.id()}
            in
            timeout={index * 100}
          >
            <div>
              <LineItem
                className={classes.lineItem}
                lineItemResource={resource}
              />
            </div>
          </Fade>
        );
      })}
    </Box>
  );
};

Body.defaultProps = {
  className: '',
};

Body.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  sectionResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(Body);
